export default function emailValidator(value: string | null): boolean {
  const pattern =
    /^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

  if (value === null || value === '') {
    return false;
  }

  const isValidFormat = pattern.test(value);
  if (!isValidFormat) {
    return false;
  }

  return true;
}
